import makeStyles from "@mui/styles/makeStyles";

export const stepIconStyle = makeStyles({
  root: {
    color: "#919191",
    height: "25px",
    width: "25px",
    alignItems: "center",
    justifyContent: "center",
  },
  active: {
    color: "#00A806",
  },
  completed: {
    color: "#00A806",
  },
  iconSize: {
    fontSize: "1.8rem",
  },
});
